// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"321":"efeedf1a","356":"a8a5656b"}[chunkId] + ".js";
};